import { CSSProperties, useContext, useEffect, useState } from "react";
import { useBjelinTranslations } from "../../hooks/TranslationHooks";
import { Col, Row } from "reactstrap";
import FormattedPrice from "../FormattedPrice";
import ContentSection from "../ContentSection";
import classNames from "classnames";
import { CartContext } from "../../functional-components/CartContext";
import { useUserProducts } from "../../hooks/ProductHooks";
import { addVat } from "../../utils/VatUtils";
import useShowPricesWithVat from "../../hooks/useShowPricesWithVat";

const CartTotal = ({
  className,
  style
}: {
  className?: string;
  style?: CSSProperties;
}) => {
  const showPricesWithVat = useShowPricesWithVat();
  const products = useUserProducts();
  const t = useBjelinTranslations();
  const { baseTotal } = useContext(CartContext);
  const [currency, setCurrency] = useState<string>();
  const [totalBasePrice, setTotalBasePrice] = useState(0);

  useEffect(() => {
    if (products) {
      const priceListCurrency = products
        .map(product => product.price && product.price.currency)
        .filter(price => !!price)[0];
      setCurrency(priceListCurrency);
      setTotalBasePrice(baseTotal(products));
    }
  }, [baseTotal, products]);

  return (
    <ContentSection
      className={classNames(className)}
      theme={"black"}
      containerTheme={"black"}
      style={style}
      ariaLabel={t("total")}
    >
      <Row>
        <Col xs={6} sm={7} md={8} className={"text-md-end text-lg-end"}>
          <div className={"font-weight-bold"}>{t("total")}:</div>
        </Col>
        <Col xs={6} sm={5} md={4} className={"text-end"}>
          <FormattedPrice
            bold_price={true}
            price={showPricesWithVat ? addVat(totalBasePrice) : totalBasePrice}
            currency={currency}
          />
          <div className={"text-muted text-small"}>{t("excl.shipping")}</div>
        </Col>
      </Row>
      {showPricesWithVat && (
        <Row>
          <Col xs={6} sm={7} md={8} className={"text-md-end text-lg-end"}>
            <div>{t("excl.vat")}:</div>
          </Col>
          <Col xs={6} sm={5} md={4} className={"text-end"}>
            <FormattedPrice price={totalBasePrice} currency={currency} />
          </Col>
        </Row>
      )}
    </ContentSection>
  );
};

export default CartTotal;
